import { Formik, Form, Field, ErrorMessage } from "formik";
import { useEffect, useState, useContext } from "react";
import * as Yup from "yup";
import { Select, Spin, Modal } from 'antd';
import FormError from "../../common/FormError";
import { EditableContext } from "../../common/EditableContextProvider";

const FormComponent = ({ errors }) => {
    const { items, loading } = useContext(EditableContext);
    const [initialValues, setInitialvalues] = useState(items.editItem);

    useEffect(() => {
        setInitialvalues(items.editItem);
    }, [items.editItem]);

    const handleSubmit = async (values, formik) => {
        await items.handle_save(values);
    }

    const validateSchema = Yup.object({
        codigo: Yup.string()
            .max(50, 'El texto es demasiado largo')
            .notRequired(),
        nombres: Yup.string()
            .min(3, 'El nombre debe tener al menos 3 letras.')
            .max(200, 'El texto es demasiado largo')
            .required('El campo nombre es obligario.'),
        apellidos: Yup.string()
            .max(200, 'El texto es demasiado largo')
            .notRequired(),
        celular: Yup.number()
            .typeError('Ingrese un número válido')
            .min(0, "Ingrese un número válido.")
            .nullable(),
        direccion: Yup.string()
            .max(300, 'El texto es demasiado largo')
            .nullable()
    });

    return (
        <div>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={validateSchema}
                enableReinitialize={true}
            >
                {
                    (formik) => (
                        <Form disabled={loading}>
                            <div className="py-1">
                                <span>ID: </span>
                                <span className="fw-bold ms-1">{sprintf('%04d', items.editItem.id)}</span>
                            </div>

                            <div className="mb-2">
                                <label htmlFor="codigo" className="form-label">
                                    Código
                                </label>
                                <Field id="codigo" name="codigo" type="text" className="form-control form-control-sm"
                                    value={formik.values.codigo ?? ""}
                                />
                                <ErrorMessage name="codigo" component={FormError} />
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-5">
                                    <label htmlFor="nombres" className="form-label">
                                        Nombres
                                        <span className="text-danger">(*)</span>
                                    </label>
                                    <Field id="nombres" name="nombres" type="text" className="form-control form-control-sm"
                                        value={formik.values.nombres ?? ""}
                                    />
                                    <ErrorMessage name="nombres" component={FormError} />
                                </div>

                                <div className="col-md-7">
                                    <label htmlFor="apellidos" className="form-label">
                                        Apellidos
                                    </label>
                                    <Field id="apellidos" name="apellidos" type="text" className="form-control form-control-sm"
                                        value={formik.values.apellidos ?? ""}
                                    />
                                    <ErrorMessage name="apellidos" component={FormError} />
                                </div>
                            </div>

                            <div className="mb-2">
                                <label htmlFor="celular" className="form-label">
                                    Celular
                                    <span className="fw-bold ms-2">(Ej. 75400000)</span>
                                </label>
                                <Field id="celular" name="celular" type="text" className="form-control form-control-sm"
                                    value={formik.values.celular ?? ""}
                                />
                                <ErrorMessage name="celular" component={FormError} />
                            </div>

                            <div className="mb-2">
                                <label htmlFor="direccion" className="form-label">
                                    Dirección
                                </label>
                                <Field id="direccion" name="direccion" type="text" className="form-control form-control-sm"
                                    value={formik.values.direccion ?? ""}
                                />
                                <ErrorMessage name="direccion" component={FormError} />
                            </div>

                            <div className="mb-2 d-flex justify-content-between">
                                <div>
                                    <span className="text-danger">(*) </span>
                                    <u>Campo obligatorio.</u>
                                </div>
                                <button type="submit" className="btn btn-sm btn-light border border-secondary px-4">
                                    {
                                        (loading) ? (
                                            <Spin size="small" />
                                        ) : "Guardar"
                                    }
                                </button>
                            </div>
                        </Form>
                    )
                }
            </Formik>
        </div>
    );
}

export default FormComponent;
